import { render, staticRenderFns } from "./PayoutsCard.vue?vue&type=template&id=d88752d4&"
import script from "./PayoutsCard.vue?vue&type=script&lang=js&"
export * from "./PayoutsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports